import { useEffect } from 'react';
export const META_PIXEL_ID = '25378909385106188';
/**
 * Track a Meta Pixel event from anywhere in the app.
 * Uses standard Meta events when applicable (InitiateCheckout, Lead, ViewContent, AddToCart, Purchase).
 *
 * Example:
 *   trackMeta('InitiateCheckout', { value: 17990, currency: 'ARS', content_name: 'Arsenal + Potenciador' })
 */
export function trackMeta(event: string, params?: Record<string, any>, options?: {
  custom?: boolean;
}) {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (!w.fbq) return;
  try {
    if (options?.custom) {
      w.fbq('trackCustom', event, params || {});
    } else {
      w.fbq('track', event, params || {});
    }
  } catch {
    /* noop */
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = META_PIXEL_ID;
    // Initialize fbq
    if (typeof window !== 'undefined') {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Load the pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize and track
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}